import { Helper } from "../../../../dev/utils/Helper";
import { BitmapTextStyleOptions, TextStyleOptions } from "../../../../dev/setting/text/IText";
import { Translator } from "../../../../dev/setting/Translator"
import { SplashView } from "../SplashController";
import { BitmapCountUp } from "../../../component/BitmapCountUp"
import { GameAssets } from "../../../config/texture/GameAssets";
import { TranslationTexts } from "../../../config/translate/TranslationTexts";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { gsap } from "gsap";

export interface RestoreData{
    fsLeft:number;
}

export class SplashFSRestore extends PIXI.Container implements SplashView  {
    
    private fsLeftTxt:PIXI.Text;
    private counter:BitmapCountUp;

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_FS_NUMBERS,
        fontSize: 48,
        tint: 0xffffff,
        letterSpacing:0
    };

    private _timeLine:gsap.core.Timeline;
    private DEFAULT_TXT_STYLE:TextStyleOptions;

    private static _presentationData:RestoreData = {
        fsLeft:1
    };


    private readonly styleTotal: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontSize: 58,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: [
            "#fffb00",
            "#c93",
        ],
        stroke: "#600",
        strokeThickness: 4
    };

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        
        this.init();
        this.visible = false;
    }

    public static setData(data:RestoreData):void{
        this._presentationData = data;
    }

    private init():void{

        // 
        this.fsLeftTxt = new PIXI.Text(Translator.translate(TranslationTexts.FREESPINS_LEFT));
        this.fsLeftTxt.style = this.styleTotal;
        this.fsLeftTxt.position = new PIXI.Point(0,-240);
        this.fsLeftTxt.anchor.set(0.5,0.5);
        this.addChild(this.fsLeftTxt);


        // COUNTER
        this.counter = this.addChild(new BitmapCountUp(this._style));
        this.counter.alpha = 1;
        this.counter.anchor = new PIXI.Point(0.5,0.5);
        this.counter.position.set(0,-160)
        this.addChild(this.counter);
        this.counter.showValue(SplashFSRestore._presentationData.fsLeft,false);

        this.onResize();
    }

    public play():gsap.core.Timeline{

        this.counter.showValue(SplashFSRestore._presentationData.fsLeft,false);
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({onStart:() => {this.visible = true}}));
        this._timeLine.fromTo(this,{alpha:0},{duration:0.5,alpha:1},0);
        return this._timeLine;
    }

    public stop():gsap.core.Timeline{
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({onComplete:() => {this.visible = false}}));
        this._timeLine.to(this,{duration:0.35,alpha:0});
        return this._timeLine;
    }

    public onResize():void{
        if(this._timeLine) this._timeLine.progress(1);
    }
}
